import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { WorkspaceApiDTO_PrivacyLock } from '../../Interfaces/APIContracts/WorkspaceApiDTO_PrivacyLock'

export interface WorkspaceActions {
    Name?: string
    Description?: string
    PrivacyLock?: number | WorkspaceApiDTO_PrivacyLock | undefined //@Steven: I have gone with more accepting type for this to get it working but not sure what this thing is.
    isWorkspaceDropdown?: boolean
    isHomePopUp?: boolean
    currentColor?: string
    workspaceId?: number
    showAddWorkspace?: boolean
    showAddWorkspaceReport?: boolean
    showShareOption?: boolean
    showAttachReportOption?: boolean
    CopyExistingReport?: boolean
    showReOrderOption?: boolean
    showEmailPDF?: boolean
    showDetachOption?: boolean
    showDeleteWorkspaceOption?: boolean
    showEditWorkspaceOption?: boolean
    isFavorites?: boolean
    isKMIs?: boolean
    appGUID?: string
    wsid?: string
}

interface WorkspaceActionsProps {
    workspace_Actions_State: WorkspaceActions[]
}

const initialState: WorkspaceActionsProps = {
    workspace_Actions_State: [],
}

const workspaceActionsReducer = createSlice({
    name: 'workspaceActions',
    initialState,
    reducers: {
        setWorkspaceActions(state, action: PayloadAction<WorkspaceActions>) {
            state.workspace_Actions_State.push(action.payload)
        },
        deleteWorkspaceActions(state, action: PayloadAction<number>) {
            const workspaceId = action.payload
            const index = state.workspace_Actions_State.findIndex(
                (workspace) => workspace.workspaceId === workspaceId
            )
            if (index !== -1) {
                state.workspace_Actions_State.splice(index, 1)
             }
             //error should be handled in componenet and not in reducers file
            //  else {
            //     console.error(`Workspace with ID ${workspaceId} not found.`)
            // }
        },
        updateWorkspaceActions(
            state,
            action: PayloadAction<{ workspaceId: number; updates: Partial<WorkspaceActions> }>
        ) {
            const { workspaceId, updates } = action.payload
            const index = state.workspace_Actions_State.findIndex(
                (workspace) => workspace.workspaceId === workspaceId
            )
            if (index !== -1) {
                //error should be handled in componenet and not in reducers file
                //console.error(`Workspace with ID ${workspaceId} not found. Adding a new entry.`)
                state.workspace_Actions_State.push({ workspaceId, ...updates })
            } else {
                state.workspace_Actions_State[index] = {
                    ...state.workspace_Actions_State[index],
                    ...updates,
                }
            }
        },
    },
})

export default workspaceActionsReducer.reducer
export const { setWorkspaceActions, updateWorkspaceActions, deleteWorkspaceActions } =
    workspaceActionsReducer.actions
